import React from 'react';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Skeleton from '@mui/material/Skeleton';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import EventBusyIcon from '@mui/icons-material/EventBusy';   
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Cancel';
import Avatar from '@mui/material/Avatar';
import { useSnackbar } from 'notistack';
import TokenService from '../../services/TokenService';



import StoreIcon from '@mui/icons-material/Store';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import HelpIcon from '@mui/icons-material/Help';
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import SaveIcon from '@mui/icons-material/Save';
import BlockIcon from '@mui/icons-material/Block';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HomeIcon from '@mui/icons-material/Home';
import DownloadIcon from '@mui/icons-material/Download';
import * as RetailStores from './RetailStores.js'; 
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import PhoneEnabledIcon from '@mui/icons-material/PhoneEnabled';
import ChatBox from '../Chat/ChatBox';
import Badge from '@mui/material/Badge'; 
import { Zoom } from '@mui/material';
import SmsIcon from '@mui/icons-material/Sms';
import RestoreIcon from '@mui/icons-material/Restore';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import StarIcon from '@mui/icons-material/Star';
import StarTwoToneIcon from '@mui/icons-material/StarTwoTone';
import StyledCheckbox from '../StyledExtensions/StyledCheckbox';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import AlertDialog from '../Modals/AlertDialog';
import EmailIcon from '@mui/icons-material/Email';
import HourglassFullIcon from '@mui/icons-material/HourglassFull';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import dayjs from 'dayjs';
import ConfirmSilenceLateNotification from '../Modals/ConfirmSilenceLateNotification';
import CircleIcon from '@mui/icons-material/Circle';

import {
    IconButton,
    Select,
    MenuItem,
    Card,
    CardContent,
    Button,
    TextField,
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Typography,
    NativeSelect,
    Paper,
    Fab
}
    from '@mui/material/'
import Image from 'mui-image';
import cloneDeep from 'lodash/cloneDeep';


var isSameOrAfter = require('dayjs/plugin/isSameOrAfter')
dayjs.extend(isSameOrAfter)

function OrderListTable(props) {
    var utc = require('dayjs/plugin/utc');
    var timezone = require('dayjs/plugin/timezone'); // dependent on utc plugin
    dayjs.extend(utc);
    dayjs.extend(timezone);

    const [selectedRow, setSelectedRow] = React.useState(-1);
    const [editingActualCansAndBottles, setEditingActualCansAndBottles] = React.useState(false);
    const [actualCansAndBottles, setActualCansAndBottles] = React.useState(0);
    const [selectedDateFilter, setSelectedDateFilter] = React.useState('ALL');
    const [sortColumn, setSortColumn] = React.useState(props.Section == 'Completed' ? 'Date' : props.Section == 'Available' ? 'AvailableDate' : 'ScheduledDate');
    const [sortDirectionAsc, setSortDirectionAsc] = React.useState(false);
    const [orders, setOrders] = React.useState(props.Orders);
    const [summaryTotalPickup, setSummaryTotalPickup] = React.useState(0);
    const [summaryEstimatedProfit, setSummaryEstimatedProfit] = React.useState(0);
    const [summaryActualProfit, setSummaryActualProfit] = React.useState(0);
    const [showSilenceConfirmation, setShowSilenceConfirmation] = React.useState(null);
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });


    const [alertDialog, setAlertDialog] = React.useState({
        show: false,
        title: '',
        message: '',
        closeButton: '',
    });

    React.useEffect(() => {
        calculateSummaryTotals(props.Orders,null); // only called once
    }, []);

    function handleConfirmSilenceLateNotificationClosed(didAccept, pickupRequest) {
        if (didAccept) {
            // update in memory
            pickupRequest.ReturnerLatePickupSilencedUntil.Data = dayjs().add(1, 'day').format('MMM D [at] h:mmA');
            let tempOrders = cloneDeep(orders);
            for (let i = 0; i < tempOrders.length; i++) {
                if (tempOrders[i].RequestID == pickupRequest.RequestID) {
                    tempOrders[i] = pickupRequest;
                    break;
                }
            }
            setOrders(tempOrders);
        }

        setShowSilenceConfirmation(null);
    }

    function actualCansAndBottlesKeyPress(e) {
        if (e.keyCode == 13) {
            validateActualCansAndBottles();
        }
    }

    function handleMessageAdded(chatMessage, order) {
        let clonedOrders = cloneDeep(orders); // deep clone so the reference is updated and setLoggedInUser re-renders
        for (let i = 0; i < clonedOrders.length; i++) {
            if (clonedOrders[i].OrderGUID === order.OrderGUID) {
                clonedOrders[i].ChatMessages.push(chatMessage);
                break;
            }
        }
        setOrders(clonedOrders);
    }

    function chatMessagesViewed(order) {
        if (order != null) {
            let clientType = '';
            if (props.loggedInUser === undefined || props.loggedInUser === null) {
                clientType = 'customer';
            }
            else if (props.loggedInUser.EmailAddress.toLowerCase() === order.Owner.toLowerCase()) {
                clientType = 'recycler'
            }
            else {
                // check if use is an Admin
                if (props.loggedInUser.UserAccess.includes('ADMIN')) {
                    clientType = 'admin'
                }
                else {
                    return;
                }
            }
            let postData = {
                clientType: clientType,
                orderGuid: order.OrderGUID
            }

            TokenService.orderServicePost(postData, 'ChatMessageViewed')
                .then((response) => {
                    response = response[Object.keys(response)[0]];
                    let orderCopy = cloneDeep(order);

                    var utc = require('dayjs/plugin/utc');
                    dayjs.extend(utc);

                    if (props.loggedInUser !== undefined) {
                        let count = 0;
                        let now = dayjs().utc().format();
                        for (let i = 0; i < orderCopy.ChatMessages.length; i++) {
                            if (orderCopy.ChatMessages[i].ViewedByRecyclerUTC == '0001-01-01T00:00:00' && orderCopy.ChatMessages[i].SenderType !== 'recycler') {
                                try {
                                    orderCopy.ChatMessages[i].ViewedByRecyclerUTC = now;
                                }
                                catch (e) {

                                }
                            }
                        }
                        let ordersCopy = [];
                        for (let i = 0; i < orders.length; i++) {
                            if (orders[i].RequestID != order.RequestID) {
                                ordersCopy.push(cloneDeep(orders[i]));
                            }
                            else {
                                ordersCopy.push(orderCopy)
                            }

                        }
                        setOrders(ordersCopy);
                        if (response.JsonData != undefined) {
                            if (response.JsonData != '') {
                                let jsonData = JSON.parse(response.JsonData);
                                let userLevel = jsonData.ReturnerLevel;
                                if (userLevel != '') {
                                    userLevel = JSON.parse(userLevel);
                                }
                                props.userLevelUpdated(userLevel);
                            }
                        }
                    }
                })
                .catch((response) => {

                });
        }
    }

    function validateActualCansAndBottles() {

        let isValid = true;
        let profitValue = actualCansAndBottles;
        if (profitValue === '') {
            profitValue = 0;
        }
        if (isNaN(actualCansAndBottles)) {
            isValid = false;
        }

        if (isValid) {
            let postData = {
                requestId: selectedRow,
                amount: profitValue
            }
            TokenService.post(postData, 'Returner_SetActualCansAndBottles')
                .then((response) => {
                   // response = response[Object.keys(response)[0]];
                    if (response.Result == "SUCCESS") {
                        let jsonData = JSON.parse(response.JsonData);
                        let updatedOrder = JSON.parse(jsonData.Order);
                        let tempOrders = [];
                        for (let i = 0; i < orders.length; i++) {
                            if (orders[i].RequestID == updatedOrder.RequestID) {
                                tempOrders.push(updatedOrder);
                            }
                            else {
                                tempOrders.push(orders[i]);
                            }
                        }
                        calculateSummaryTotals(tempOrders, null);
                        setOrders(tempOrders);
                        setEditingActualCansAndBottles(false);
                    }
                })
                .catch((response) => {
                    enqueueSnackbar('Oops, something went wrong', {
                        variant: 'error',
                    });
                });

           
        }
    }

    const handleRowClick = (e, order) => {
        if (order.RequestID == selectedRow) {
            // same row clicked again
            setSelectedRow(0);
        }
        else {
            setSelectedRow(order.RequestID);
        }
        setEditingActualCansAndBottles(false);
        setActualCansAndBottles(0);
    }

    
   

    function buildCompletedPickupsSummaryArea() {
        return (
            <Card style={{ marginBottom: '10px', backgroundColor:'var(--sipzee-yellow-3)' }}>
                <CardContent>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ width: '130px', display:'flex', marginRight:'3px', justifyContent:'center' }}>
                            <MobileView>
                                <NativeSelect value={selectedDateFilter}
                                 
                                    onChange={handleDateFilterChange}
                                    inputProps={{
                                        name: 'age',
                                        id: 'uncontrolled-native',
                                    }}>
                                    <option value='ALL'>All Time</option>
                                    <option value='This Week'>This Week</option>
                                    <option value='Last Week'>Last Week</option>
                                    <option value='This Month'>This Month</option>
                                    <option value='Last Month'>Last Month</option>
                                    <option value='This Year'>This Year</option>
                                    <option value='Last Year'>Last Year</option>
                                </NativeSelect>
                            </MobileView>
                            <BrowserView>

                                <Select variant="filled"
                                  
                                    value={selectedDateFilter}
                                    onChange={handleDateFilterChange}
                                    inputProps={{
                                        name: 'age',
                                        id: 'uncontrolled-native',
                                    }}>
                                    <MenuItem value='ALL'>All Time</MenuItem>
                                    <MenuItem value='This Week'>This Week</MenuItem>
                                    <MenuItem value='Last Week'>Last Week</MenuItem>
                                    <MenuItem value='This Month'>This Month</MenuItem>
                                    <MenuItem value='Last Month'>Last Month</MenuItem>
                                    <MenuItem value='This Year'>This Year</MenuItem>
                                    <MenuItem value='Last Year'>Last Year</MenuItem>
                                </Select>
                            </BrowserView>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', alignSelf: 'stretch', justifyContent: 'space-between' }}>
                            <div><Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>Pickups</Typography></div>
                            <div>{summaryTotalPickup}</div>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', alignSelf: 'stretch', justifyContent: 'space-between' }}>
                            <div><Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>Estimated Profit</Typography></div>
                            <div>{formatter.format(summaryEstimatedProfit)}</div>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', alignSelf: 'stretch', justifyContent:'space-between' }}>
                            <div><Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>Actual Profit</Typography></div>
                            <div>{(isNaN(summaryActualProfit) ? <span style={{ fontSize: '8pt' }}> {summaryActualProfit}</span> : formatter.format(summaryActualProfit))}</div>
                        </div>

                    </div>
                    <div style={{ display: 'flex' }}>
                        {orders.length === 0 ?
                            null
                            :
                            <Fab size='small' onClick={handleExcelFileDownload }>
                                <>
                                    <Image src="images/excel.svg" height={25} width={25} />
                                    <DownloadIcon style={{ position: 'absolute', height: '15px', width: '15px', left: '20px', top: '20px', color: 'var(--sipzee-yellow)' }} />
                                </>
                            </Fab>
                        }
                    </div>
                </CardContent>
            </Card>    
        )
    }

    function handleExcelFileDownload() {
        var data = [];

        for (let i = 0; i < orders.length; i++) {
            data.push(
                {
                    'Pickup Date': new Date(orders[i].PickupTimestamp.Data).toLocaleString('en-US', { dateStyle: 'short' }) + " " + new Date(orders[i].PickupTimestamp.Data).toLocaleString('en-US', { timeStyle: 'short' }),
                   
                    'Quantity': parseInt(orders[i].Quantity_Of_Cans_Bottles),
                    'Actual Quantity': orders[i].ActualCansAndBottles === 0 ? 'N/A' : parseInt(orders[i].ActualCansAndBottles),
                    'Estimated Profit': parseFloat(calculateEstimatedProfit(orders[i])).toFixed(2),
                    'Actual Profit': orders[i].ActualProfit === 0 ? 'N/A' : formatter.format(orders[i].ActualProfit).replace('$',''),
                }
            )
        }

        const worksheet = XLSX.utils.json_to_sheet(data);

        // (C2) CREATE NEW EXCEL "FILE"
        var workbook = XLSX.utils.book_new();
        workbook.SheetNames.push("Orders");
        workbook.Sheets["Orders"] = worksheet;

        worksheet["!cols"] = [{ wch: 20 }, { wch: 10 }, { wch: 14 }, { wch: 14 }, { wch: 10 }]; // set column A width to 10 characters

        // (C3) "FORCE DOWNLOAD" XLSX FILE
        XLSX.writeFile(workbook, "Completed Orders.xlsx");
    }

    function calculateEstimatedProfit(order) {
        let tipAmount = parseFloat(order.TipAmount);
        let estProfit = (order.Quantity_Of_Cans_Bottles * 0.1 * .4 + tipAmount);
        return estProfit;
    }

    function filterAndSort(column, directionAsc, dateFilterValue) {
       // let sortedOrders = [...orders];
        let today = new Date();

        let prevMonday = new Date();
        prevMonday.setDate(prevMonday.getDate() - (prevMonday.getDay() + 6) % 7);

        let prevMonday2 = new Date();
        prevMonday2.setDate(prevMonday.getDate() - 7);

        let beginningOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        let beginningOfPrevMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        beginningOfPrevMonth.setMonth(beginningOfPrevMonth.getMonth() - 1);

        let beginningOfYear = new Date(today.getFullYear(), 0, 1);
        let beginningOfPrevYear = new Date(today.getFullYear() - 1, 0, 1);
        // filter first
        let tempOrders = [];
        for (let i = 0; i < props.Orders.length; i++) {
            if (dateFilterValue === 'ALL') {
                tempOrders.push(props.Orders[i]);
            }
            else if (dateFilterValue === 'This Week') {
                //prevMonday to today
                if (new Date(props.Orders[i].PickupTimestamp.Data).getTime() > today.getTime()) {
                    tempOrders.push(props.Orders[i]);
                }
        
            }
            else if (dateFilterValue === 'Last Week') {
                //prevMonday2 to prevMonday
                if (new Date(props.Orders[i].PickupTimestamp.Data).getTime() > prevMonday2.getTime() &&
                    new Date(props.Orders[i].PickupTimestamp.Data).getTime() < prevMonday.getTime()) {
                    tempOrders.push(props.Orders[i]);
                }
                
            }
            else if (dateFilterValue === 'This Month') {
                if (new Date(props.Orders[i].PickupTimestamp.Data).getTime() > beginningOfMonth.getTime()) {
                    tempOrders.push(props.Orders[i]);
                }
            }
            else if (dateFilterValue === 'Last Month') {
                if (new Date(props.Orders[i].PickupTimestamp.Data).getTime() > beginningOfPrevMonth.getTime() &&
                    new Date(props.Orders[i].PickupTimestamp.Data).getTime() < beginningOfMonth.getTime()) {
                    tempOrders.push(props.Orders[i]);
                }
            }
            else if (dateFilterValue === 'This Year') {
                if (new Date(props.Orders[i].PickupTimestamp.Data).getTime() > beginningOfYear.getTime()) {
                    tempOrders.push(props.Orders[i]);
                }
            }
            else if (dateFilterValue === 'Last Year') {
                if (new Date(props.Orders[i].PickupTimestamp.Data).getTime() > beginningOfPrevYear.getTime() &&
                    new Date(props.Orders[i].PickupTimestamp.Data).getTime() < beginningOfYear.getTime()) {
                    tempOrders.push(props.Orders[i]);
                }
            }
            
        }

        // calculate summary totals
        calculateSummaryTotals(tempOrders, dateFilterValue);

        if (column == 'PickupDate') {
            tempOrders.sort(pickupDateSorter);
        }
        else if (column == 'Scheduled Pickup Date')
        {
            tempOrders.sort(scheduledPickupDateSorter);
        }
        else if (column == 'Quantity') {
            tempOrders.sort(quantitySorter);

        }
        else if (column == 'Estimated Profit') {
            tempOrders.sort(estimatedProfitSorter);
        }
        else if (column == 'Actual Profit') {
            tempOrders.sort(actualProfitSorter);
        }
        else if (column == 'Status') {
            tempOrders.sort(dynamicSort('Status_Reason'));
        }
        else if (column == 'City') {
            tempOrders.sort(dynamicSort('CustomerAddress_City'));
        }
        else if (column == 'Returner') {
            tempOrders.sort(dynamicSort('Owner_FirstName'));
        }
        else if (column == 'CustomerName') {
            tempOrders.sort(dynamicSort('CustomerName'));
        }
        else if (column == 'ClosedDate') {
            tempOrders.sort(closedDateSorter);
        }

        if (!directionAsc) {
            tempOrders.reverse();
        }

        setOrders(tempOrders);
    }

    function calculateSummaryTotals(orderList, dateFilter) {
        if (orderList == null) {
            return;
        }
        let totalPickup = 0;
        let totalEstimatedProfit = 0;
        let totalActualProfit = 0;
        let allActualProfitEntered = true;
        totalPickup = orderList.length;
        for (let i = 0; i < orderList.length; i++) {
            totalEstimatedProfit += calculateEstimatedProfit(orderList[i]);
            totalActualProfit += orderList[i].ActualProfit;
            if (orderList[i].ActualProfit == 0) {
                allActualProfitEntered = false;
            }
        }

        setSummaryTotalPickup(totalPickup);
        setSummaryEstimatedProfit(totalEstimatedProfit);
        if (allActualProfitEntered) {
            setSummaryActualProfit(totalActualProfit);
        }
        else {
            setSummaryActualProfit(<IconButton onClick={(e) => showMoreInfo('ActualProfit') }><HelpIcon /></IconButton>);
          
        }
    }

    function showMoreInfo(infoType) {
        if (infoType == 'ActualProfit') {
            setAlertDialog({
                show: true,
                title: '',
                message:
                    <div style={{ display: 'flex' }}>
                        <HelpOutlineIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 50 }} style={{ alignSelf: 'center' }} />
                        <div style={{ marginLeft: '15px', marginRight: '15px' }}>
                            <div>
                                Not all pickups for the selected range have Actual Cans and Bottle counts.
                            </div>
                            <div style={{marginTop:'20px'} }>
                                You can select a pickup and optionally provide the Actual counts to track this.
                            </div>
                        </div>
                      
                    </div>,
                closeButton: 'Ok',
            });
        }
        else if (infoType == 'MustRecycleFirst') {
            setAlertDialog({
                show: true,
                title: '',
                message:
                    <div style={{ display: 'flex' }}>
                        <img src='images/RecycleFirstIndicatorGreen.svg' style={{ height: '40px', alignSelf:'center' }} />
                        <div style={{ marginLeft: '15px', marginRight: '15px' }}>
                            <div>
                               Must Recycle First
                            </div>
                            <div style={{ marginTop: '20px' }}>
                                This pickup must be recycled before purchase. 
                                You will use the Recycle First option when picking up.
                            </div>
                        </div>

                    </div>,
                closeButton: 'Ok',
            });
        }
        else if (infoType == 'ContinuousPickup') {
            setAlertDialog({
                show: true,
                title: '',
                message:
                    <div style={{ display: 'flex' }}>
                        <img src='images/ContinuousPickupIcon.png' style={{ height: '40px', alignSelf:'flex-start' }} />
                        <div style={{ marginLeft: '15px', marginRight: '15px' }}>
                            <div style={{fontWeight:'bold', marginTop:'5px'}}>
                               Continuous Pickup
                            </div>
                            <div style={{ marginTop: '20px' }}>
                                <div><CircleIcon sx={{height:'12px'}} /> Continuous pickups are typically extra large.</div>
                                <div><CircleIcon sx={{ height: '12px' }} /> You can take as many as you want.</div>
                                <div><CircleIcon sx={{ height: '12px' }} /> You will use the Recycle First option.</div>
                                <div><CircleIcon sx={{ height: '12px' }} /> Payment is based on the final quantity collected.</div>
                                
                            </div>
                            <div style={{ marginTop: '20px' }}>The customer will likely continue to create pickups until all cans & bottles are gone.</div>
                        </div>

                    </div>,
                closeButton: 'Ok',
            });
        }

    }

    function handleDateFilterChange(e) {
        setSelectedDateFilter(e.target.value);
        filterAndSort(sortColumn, sortDirectionAsc, e.target.value);
    }

    function sortingChanged(column) {
        let directionAsc;
        if (sortColumn == column) {
            setSortDirectionAsc(!sortDirectionAsc);
            directionAsc = !sortDirectionAsc;
        }
        else {
            setSortColumn(column);
            setSortDirectionAsc(true);
            directionAsc = true;
        }

        // redo the sorting:
        filterAndSort(column, directionAsc, selectedDateFilter);
    }

    //#region Sorters

    function pickupDateSorter(a, b) {
        return new Date(a.PickupTimestamp.Data).getTime() - new Date(b.PickupTimestamp.Data).getTime();
    }

    function scheduledPickupDateSorter(a, b) {
        return new Date(a.ScheduledPickUpDate).getTime() - new Date(b.ScheduledPickUpDate).getTime();
    }

    function quantitySorter(a, b) {
        return parseInt(a.Quantity_Of_Cans_Bottles) - parseInt(b.Quantity_Of_Cans_Bottles);
    }

    function estimatedProfitSorter(a, b) {
        return calculateEstimatedProfit(a) - calculateEstimatedProfit(b);
    }

    function actualProfitSorter(a, b) {
        return (a.ActualProfit == undefined ? 0 : parseFloat(a.ActualProfit)) - (b.ActualProfit == undefined ? 0 : parseFloat(b.ActualProfit))
    }

    function closedDateSorter(a, b) {
        let closedA;
        let closedB;

        if (a.Status_Reason == 'Paid') {
            closedA = dayjs(a.PickupTimestamp.Data);
        }
        else if (a.Status_Reason == 'Cancelled') {
            closedA = dayjs(a.Created_Date_Time_UTC.Data);
        }


        if (b.Status_Reason == 'Paid') {
            closedB = dayjs(b.PickupTimestamp.Data);
        }
        else if (b.Status_Reason == 'Cancelled') {
            closedB = dayjs(b.Created_Date_Time_UTC.Data);
        }

        if (closedB.isSameOrAfter(closedA)) {
            return 1;
        }
        return -1;

    }

    function dynamicSort(property) {
        return function (a, b) {
            return (a[property].trim().toLowerCase() < b[property].trim().toLowerCase()) ? -1 : (a[property].trim().toLowerCase() > b[property].trim().toLowerCase()) ? 1 : 0;
        }
    }

    //#endregion
       
    //#region Completed Orders section

    function buildCompletedOrderHeader() {
        return (<div style={{ display: 'flex', width: '100%', minHeight: '30px' }}>
            <div style={{ width: '70px', display: 'flex' }} onClick={(e) => sortingChanged('PickupDate')}>
                <Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>Date</Typography>
                {sortColumn == 'PickupDate' && sortDirectionAsc ?
                    <KeyboardArrowDownIcon />
                    : null
                }
                {sortColumn == 'PickupDateDate' && !sortDirectionAsc ?
                    <KeyboardArrowUpIcon />
                    : null
                }
            </div>
            <div style={{ width: '80px', display: 'flex' }} onClick={(e) => sortingChanged('Quantity')}>
                <Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>Quantity</Typography>
                {sortColumn == 'Quantity' && sortDirectionAsc ?
                    <KeyboardArrowDownIcon />
                    : null
                }
                {sortColumn == 'Quantity' && !sortDirectionAsc ?
                    <KeyboardArrowUpIcon />
                    : null
                }
            </div>
            <div style={{ width: '80px', display: 'flex' }} onClick={(e) => sortingChanged('Estimated Profit')}>
                <Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>Estimated Profit</Typography>
                {sortColumn == 'Estimated Profit' && sortDirectionAsc ?
                    <KeyboardArrowDownIcon />
                    : null
                }
                {sortColumn == 'Estimated Profit' && !sortDirectionAsc ?
                    <KeyboardArrowUpIcon />
                    : null
                }
            </div>
            <div style={{ width: '80px', display: 'flex' }} onClick={(e) => sortingChanged('Actual Profit')}>
                <Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>Actual Profit</Typography>
                {sortColumn == 'Actual Profit' && sortDirectionAsc ?
                    <KeyboardArrowDownIcon />
                    : null
                }
                {sortColumn == 'Actual Profit' && !sortDirectionAsc ?
                    <KeyboardArrowUpIcon />
                    : null
                }
            </div>
            <div style={{ flexGrow: 1 }}></div>
        </div>);
    }

    function buildCompletedOrderRow(order) {
        return (<div style={{ display: 'flex', width: '100%', minHeight: '30px', fontSize: '10pt' }}>
            <div style={{ width: '70px' }}>
                {new Date(order.PickupTimestamp.Data).toLocaleString('en-US', { dateStyle: 'short' })}
            </div>
            <div style={{ width: '80px' }}>
                {order.Quantity_Of_Cans_Bottles}
            </div>
            <div style={{ width: '80px' }}>
                {formatter.format(calculateEstimatedProfit(order))}
            </div>
            <div style={{ width: '80px' }}>
                {order.ActualProfit !== 0 ?
                    formatter.format(parseFloat(order.ActualProfit))
                    :
                    '?'
                }


            </div>
            <div style={{ flexGrow: 1 }}></div>
        </div>);
    }

    function buildCompletedOrderExpansionArea(pickupRequest) {
        let mapUrl = 'http://maps.apple.com/?q=' + pickupRequest.CustomerAddress_Street + '+' + pickupRequest.CustomerAddress_City + '+' + pickupRequest.CustomerAddress_State + '+' + pickupRequest.CustomerAddress_Zipcode;

        return (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', padding: '3px' }}>
                <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}><div>Picked up on: </div><div>{new Date(pickupRequest.PickupTimestamp.Data).toLocaleString('en-US', { weekday: 'short' })} {new Date(pickupRequest.PickupTimestamp.Data).toLocaleString('en-US', { dateStyle: 'short' })} at {new Date(pickupRequest.PickupTimestamp.Data).toLocaleString('en-US', { timeStyle: 'short' })}</div></div>
                <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}><div>Estimated Bottles & Cans:</div><div>{pickupRequest.BottleSlipTotalQuantity > 0 ? pickupRequest.BottleSlipTotalQuantity : pickupRequest.Quantity_Of_Cans_Bottles}</div></div>
                <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'flex-end', alignContent: 'center', width: '100%', minHeight: '30px' }}>

                    <div style={{ marginRight: 'auto', alignSelf: 'center' }}>Actual Cans and Bottles:</div>

                    {editingActualCansAndBottles ?
                        <div style={{ alignSelf: 'center' }}>
                            <IconButton onClick={() => setEditingActualCansAndBottles(!editingActualCansAndBottles)}><BlockIcon sx={{ color: 'var(--sipzee-red)' }} /></IconButton>
                            <IconButton onClick={() => validateActualCansAndBottles()}><SaveIcon sx={{ color: 'var(--sipzee-green)' }} /></IconButton>
                        </div>

                        :

                        <IconButton style={{ alignSelf: 'center' }} onClick={() => {
                            setEditingActualCansAndBottles(!editingActualCansAndBottles);
                            setActualCansAndBottles(pickupRequest.ActualCansAndBottles);

                        }}>
                            {pickupRequest.ActualProfit == undefined || pickupRequest.ActualProfit == 0 ?
                                <AddCircleOutlineIcon />
                                :
                                <EditIcon />}
                        </IconButton>
                    }



                    {editingActualCansAndBottles ?
                        <TextField style={{ width: '100px', alignSelf: 'center' }} autofocus variant="outlined" onChange={(e) => setActualCansAndBottles(e.target.value)} inputProps={{ inputMode: 'numeric', pattern: '[^0-9.-]+/g,""' }} value={actualCansAndBottles} onKeyDown={(e) => actualCansAndBottlesKeyPress(e)} />
                        :
                        <div style={{ alignSelf: 'center' }}>{(pickupRequest.ActualCansAndBottles == undefined ? '(optional)' : '')} {pickupRequest.ActualCansAndBottles}</div>
                    }


                </div>
                <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'flex-start', marginTop: '-8px' }}>
                    <div style={{ fontSize: '10pt', fontStyle: 'italic' }}>Optional for your own tracking</div>
                </div>

                {isLessThan24Hours(new Date(pickupRequest.PickupTimestamp.Data)) ?
                    <>
                    <div style={{
                        alignSelf: 'flex-start',
                        width: '100%',
                        minHeight: '35px',
                        borderTop: '1px solid #efefef',
                        borderBottom: '1px solid #efefef',
                        marginTop: '10px',
                        marginBottom: '10px',
                        textAlign: 'right'
                        }}>
                            <div style={{ textAlign: 'left', fontStyle:'italic' }} >This info will show for 24 hours after completing a pickup</div>
                <div style={{ textAlign: 'left', fontWeight: 'bold' }}>Customer Communication</div>
                

                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Fab color='primary' onClick={() => handleShowCallCustomerDialog(pickupRequest)} style={{ marginRight: '10px' }}><PhoneEnabledIcon /></Fab>
                                <ChatBox FloatingButton={false} order={pickupRequest} messagesViewed={(msgOrder) => chatMessagesViewed(msgOrder)} loggedInUser={props.loggedInUser} onMessageAdded={(chatMessage) => handleMessageAdded(chatMessage, pickupRequest)} recipient='recycler' />

                            </div>
                            <div style={{ textAlign: 'left', fontSize: '10pt', fontStyle: 'italic' }}>Please communicate with the customer as necessary to ensure a smooth pickup process.</div>
                        </div>
                        <div style={{ textAlign: 'left', marginTop: '15px' }}>
                            <div style={{ textAlign: 'left', fontWeight: 'bold' }}>Customer Address</div>
                            {pickupRequest.CustomerName} {pickupRequest.CustomerLastname}
                        </div>
                        <a href={mapUrl}>
                        <div style={{ textAlign: 'left' }}>
                            
                            <div>{pickupRequest.CustomerAddress_Street}</div>
                            {(pickupRequest.CustomerAddress_Apt_Suit_Other == '' ? null
                                : <div> pickupRequest.CustomerAddress_Apt_Suit_Other</div>)
                            }
                                <div>{pickupRequest.CustomerAddress_City}, {pickupRequest.CustomerAddress_State} {pickupRequest.CustomerAddress_Zipcode}</div></div>
                           </a>
                    </>
                    :
                    null
                }
            </div>)
    }

    function isLessThan24Hours(dateToCheck) {
        const now = new Date();
        let oneDay = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
       
        // Get the time difference
        const timeDiff = Math.abs(now - dateToCheck);

        // Check if the difference is less than 24 hours
        return timeDiff < oneDay;
    }

    //#endregion
  
    //#region MyOpen Orders section


    function buildOpenOrderHeader() {
        return (<div style={{ display: 'flex', width: '100%', minHeight: '30px' }}>
            <div style={{ width: '150px', display: 'flex' }} onClick={(e) => sortingChanged('Scheduled Pickup Date')}>
                <Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>When</Typography>
                {sortColumn == 'Scheduled Pickup Date' && sortDirectionAsc ?
                    <KeyboardArrowDownIcon />
                    : null
                }
                {sortColumn == 'Scheduled Pickup Date' && !sortDirectionAsc ?
                    <KeyboardArrowUpIcon />
                    : null
                }
            </div>
            <div style={{ width: '150px', display: 'flex' }} onClick={(e) => sortingChanged('Location')}>
                <Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>Where</Typography>
                {sortColumn == 'Location' && sortDirectionAsc ?
                    <KeyboardArrowDownIcon />
                    : null
                }
                {sortColumn == 'Location' && !sortDirectionAsc ?
                    <KeyboardArrowUpIcon />
                    : null
                }
            </div>
            <div style={{ width: '80px', display: 'flex' }} onClick={(e) => sortingChanged('Estimated Profit')}>
                <Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>Est Profit</Typography>
                {sortColumn == 'Estimated Profit' && sortDirectionAsc ?
                    <KeyboardArrowDownIcon />
                    : null
                }
                {sortColumn == 'Estimated Profit' && !sortDirectionAsc ?
                    <KeyboardArrowUpIcon />
                    : null
                }
            </div>
            <div style={{ flexGrow: 1 }}></div>
        </div>);
    }


    function buildOpenOrderRow(order) {
        let whenDate = '';
        let availDate = (dayjs(order.ScheduledPickUpDate));
        let tomorrowDate = dayjs().add(1, 'day').endOf('day');

        let startTime = order.EstPickUpWindow.split('_')[0];
        let endTime = order.EstPickUpWindow.split('_')[1];

        let isRecycleFirstIcon = null;

        if (order.EstPickUpWindow == 'In Process' && order.RecyclerRequestedByCustomerTimestampUTC.Data != '') {
            // this recycler was requested by the customer, but the recycler has not yet scheduled it.
            let requestCreatedUTC = dayjs.utc(order.RecyclerRequestedByCustomerTimestampUTC.Data + ' GMT');;

            let currentUTC = dayjs.utc();
            let requestExpires = dayjs(requestCreatedUTC).add(1, 'day');
            let claimIn = null;
            let minutesUntilExpire = Math.abs(requestExpires.diff(currentUTC, 'minute', true));

            if (minutesUntilExpire < 60) {
                claimIn = Math.round(minutesUntilExpire) + ' mins';
            }
            else {
                claimIn = Math.round(minutesUntilExpire / 60) + ' hours';
            }
            startTime = <div style={{ display: 'flex', borderTop: '1px solid #efefef', marginTop: '2px', paddingTop: '2px' }}><div>Must Claim within {claimIn}</div><StarTwoToneIcon className={'yellowStarBlackOutline'} style={{ alignSelf:'center', fontSize:'30px' }} /></div>;
            endTime = null;
            availDate = (dayjs(order.CustomerDateAvailableForPickup.Data));
            
        }
        else {
            if (startTime.indexOf(':00') > -1) {
                startTime = startTime.toLowerCase().replace(':00', '');
            }

            if (endTime.indexOf(':00') > -1) {
                endTime = endTime.toLowerCase().replace(':00', '');
            }
            startTime += '-';
        }

        // order.ServiceArea = 'Claimed'
        //availDate = dayjs('2022-11-25');

       
        let hoursSinceFirstRecycle = 0;

        if (order.RecycleFirstTimestampUTC.Data !== null) {
            hoursSinceFirstRecycle = dayjs.utc().diff(dayjs(order.RecycleFirstTimestampUTC.Data), 'hour');
            isRecycleFirstIcon = <div style={{display:'flex', marginTop:'10px'} }>
                <Image wrapperStyle={{ width: '40px' }} src={hoursSinceFirstRecycle < 24 ? 'images/RecycleFirstIndicatorGreen.svg' : 'images/RecycleFirstIndicatorRed.svg'} style={{ height: '40px', width: '40px' }} />
                <div style={{alignSelf:'center'} }>Recycle First</div>
            </div>;
        }

        if (order.IsLate) {
            whenDate = <div><Paper className='OpenOrderAvailability' style={{ backgroundColor: 'var(--sipzee-red-2)',minWidth:'80px', left:'-5px' }}>
                <div>{availDate.format('dddd MM/DD')}</div>
                <div>{startTime}{endTime}</div>
            </Paper>
                {isRecycleFirstIcon}
            </div>;
        }
        else if (availDate < dayjs().endOf('day')) {
            whenDate = <div><Paper className='OpenOrderAvailability' style={{ backgroundColor: 'var(--sipzee-green-2)', minWidth: '80px', left: '-5px' }}><div>Today</div><div>{startTime}{endTime}</div></Paper>{isRecycleFirstIcon}</div>;
        }
        else if (availDate < tomorrowDate) {
            whenDate = <div><Paper className='OpenOrderAvailability' style={{ backgroundColor: 'var(--sipzee-yellow-2)', minWidth: '80px', left: '-5px' }}><div>Tomorrow</div><div>{startTime}{endTime}</div></Paper>{isRecycleFirstIcon}</div>;
        }
        else {
            whenDate = <div><Paper className='OpenOrderAvailability' style={{ backgroundColor: 'var(--sipzee-yellow-3)', minWidth: '80px', textAlign: 'left', left: '-5px' }}>
                    <div>{availDate.format('dddd MM/DD')}</div>
                <div>{startTime}{endTime}</div>
                </Paper>
                {isRecycleFirstIcon}
             </div>;
        }

        let where = <div style={{ textAlign: 'left' }}>
            <div>{order.CustomerAddress_Street}</div>
            {(order.CustomerAddress_Apt_Suit_Other == '' ? null : <div>order.CustomerAddress_Apt_Suit_Other</div>)}
            <div>{order.CustomerAddress_City}, {order.CustomerAddress_State} {order.CustomerAddress_Zipcode}</div></div>

        let mapUrl = 'http://maps.apple.com/?q=' + order.CustomerAddress_Street + '+' + order.CustomerAddress_City + '+' + order.CustomerAddress_State + '+' + order.CustomerAddress_Zipcode;

        let unreadMessageCount = 0;
        for (let i = 0; i < order.ChatMessages.length; i++) {
            if (order.ChatMessages[i].ViewedByRecyclerUTC == '0001-01-01T00:00:00' && 'recycler' !== order.ChatMessages[i].SenderType) {
                unreadMessageCount++;
            }
        }

        console.log('unreadMessageCount=' + unreadMessageCount);

        return (<div>
                <div style={{ display: 'flex', width: '100%', minHeight: '30px', fontSize: '10pt' }}>
                <div style={{ width: '150px', minWidth:'150px' }}>
                    {whenDate}
                    {unreadMessageCount == 0 ? null :
                        <div style={{ position: 'absolute', left: '100px', top: '40%' }}>
                            <Badge badgeContent={unreadMessageCount}
                                color="sipzeeRed"
                                overlap="circular"
                                sx={{ zIndex: 1051 }}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                            >
                                <SmsIcon />
                            </Badge>
                        </div>
                    }
                </div>
                <div style={{ width: '110px', textAlign:'left' }}>
                    <a href={mapUrl} target='_blank'>{where }</a>
                </div>
                <div style={{ width: '80px' }}>
                    {formatter.format(calculateEstimatedProfit(order))}
                </div>

               
            </div>
            <div style={{ display: 'flex', width: '100%' }}>
                {order.MustRecycleFirst == false ? null :
                    <div style={{ marginTop: '5px', marginRight:'10px' }}>
                        <IconButton style={{ backgroundColor: 'rgba(0, 0, 0, 0.08)' }} onClick={() => showMoreInfo('MustRecycleFirst') }>
                            <img src='images/RecycleFirstIndicatorGreen.svg' style={{ height: '30px' }} />
                        </IconButton>
                        <div style={{fontSize:'9pt'} }>Must Recycle First</div>
                    </div>
                }
                {order.PickupType == 'Continuous' &&
                    <div style={{ marginTop: '5px', marginRight:'10px' }}>
                        <IconButton style={{ backgroundColor: 'rgba(0, 0, 0, 0.08)' }} onClick={() => showMoreInfo('ContinuousPickup')}>
                            <img src='images/ContinuousPickupIcon.png' style={{ height: '30px' }} />
                        </IconButton>
                        <div style={{ fontSize: '9pt' }}>Continuous Pickup</div>
                    </div>
                }
            </div>
        </div>);
    }

    function buildOpenOrderExpansionArea(pickupRequest) {
        let selectedStores = RetailStores.getStoreIcons(pickupRequest);

        let recyclerRequestedByCustomer = null;
        if (pickupRequest.EstPickUpWindow == 'In Process' && pickupRequest.RecyclerRequestedByCustomerTimestampUTC.Data != '') {
            // this recycler was requested by the customer, but the recycler has not yet scheduled it.
            let requestCreatedUTC = dayjs.utc(pickupRequest.RecyclerRequestedByCustomerTimestampUTC.Data + ' GMT');;

            let currentUTC = dayjs.utc();
            let requestExpires = dayjs(requestCreatedUTC).add(1, 'day');
            let claimIn = null;
            let minutesUntilExpire = Math.abs(requestExpires.diff(currentUTC, 'minute', true));
          
            if (minutesUntilExpire < 60) {
                claimIn = Math.round(minutesUntilExpire) + ' mins';
            }
            else {
                claimIn = Math.round(minutesUntilExpire / 60) + ' hours';
            }
            recyclerRequestedByCustomer = <div style={{ display: 'flex', color: 'red', marginTop: '5px', marginBottom: '10px' }}><StarTwoToneIcon className={'yellowStarBlackOutline'} style={{ alignSelf: 'center', fontSize: '45px' }} /><div>The customer requested you for this pickup. You must Schedule it within {claimIn} to accept it.</div></div>;

        }

        return (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', padding: '3px' }}>
                {recyclerRequestedByCustomer}
                {pickupRequest.IsLate ?
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                        {pickupRequest.ReturnerLatePickupSilencedUntil.Data === null ?
                            <div style={{ alignSelf: 'center' }}>
                                This pickup is late.
                            </div>
                            : null
                        }
                        <div>
                            {
                                pickupRequest.ReturnerLatePickupSilencedUntil.Data === null ?
                                    <Fab onClick={() => { setShowSilenceConfirmation(pickupRequest) }}>
                                        <VolumeOffIcon style={{ color: 'var(--sipzee-red)' }} />
                                    </Fab>
                                    :
                                    <div style={{ display: 'flex' }}>
                                        <VolumeOffIcon style={{ color: 'var(--sipzee-red)', alignSelf: 'center' }} />
                                        <div>Notifications Silenced until {pickupRequest.ReturnerLatePickupSilencedUntil.Data}
                                        </div>
                                    </div>
                            }

                        </div>
                    </div>
                    :
                    null
                }

                {
                    pickupRequest.RecycleFirstTimestampUTC.Data != null ?
                        <>
                         
                            <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}><div>Actual Quantity: </div><div>{pickupRequest.BottleSlipTotalQuantity}</div></div>
                            <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}><div>Bottle slips uploaded:</div><div>{pickupRequest.BottleSlipCount}</div></div>
                                

                            {(pickupRequest.TipAmount === '' || pickupRequest.TipAmount === '0')
                                ?
                                <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px', color: 'var(--sipzee-red)' }}><div>Your Purchase Cost: </div><div>{formatter.format(pickupRequest.RecyclerPurchaseCost)}</div></div>

                                :
                                <>
                                    <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}><div>Purchase Cost: </div><div>{formatter.format(pickupRequest.RecyclerPurchaseCost + parseFloat(pickupRequest.TipAmount))}</div></div>
                                    <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}><div>Tip Amount:</div><div>({formatter.format(pickupRequest.TipAmount)})</div></div>
                                    <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px', color: 'var(--sipzee-red)' }}><div>Your Purchase Cost: </div><div>{formatter.format(pickupRequest.RecyclerPurchaseCost)}</div></div>
                                </>
                            }

                            <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}><div>Profit:</div><div style={{ borderTop: '1px solid black', fontWeight: 'bold' }}>{formatter.format((pickupRequest.BottleSlipTotalQuantity * .1) - pickupRequest.RecyclerPurchaseCost)}</div></div>
                        </>
                        :
                        <>
                            <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}><div>Estimated Quantity:</div><div>{pickupRequest.Quantity_Of_Cans_Bottles}</div></div>

                            <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}>
                                <div>Estimated Bottle Value:</div>
                                <div style={{textAlign:'right'}}>
                                    {pickupRequest.PickupType == 'On Demand' ?
                                        formatter.format(pickupRequest.Quantity_Of_Cans_Bottles * .1)
                                        :
                                        <>Depends on the amount you pickup.</>
                                    }
                                </div>
                            </div>


                            {(pickupRequest.TipAmount === '' || pickupRequest.TipAmount === '0')
                                ?
                                <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px', color: 'var(--sipzee-red)' }}>
                                    <div>Your Purchase Cost: </div>
                                    <div>
                                        {pickupRequest.PickupType == 'On Demand' ?
                                            formatter.format(pickupRequest.RecyclerPurchaseCost)
                                            :
                                            <>Depends on the amount you pickup.</>
                                        }
                                    </div>
                                </div>

                                :
                                <>
                                    <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}>
                                        <div>Purchase Cost: </div>
                                        <div>
                                            {pickupRequest.PickupType == 'On Demand' ? 
                                                formatter.format(pickupRequest.RecyclerPurchaseCost + parseFloat(pickupRequest.TipAmount))
                                            :
                                                <>Depends on the amount you pickup.</>
                                            }
                                        </div>
                                    </div>
                                    <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}><div>Tip Amount:</div><div>({formatter.format(pickupRequest.TipAmount)})</div></div>
                                    <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px', color: 'var(--sipzee-red)' }}>
                                        <div>Your Purchase Cost: </div>
                                        <div>
                                            {pickupRequest.PickupType == 'On Demand' ?
                                                formatter.format(pickupRequest.RecyclerPurchaseCost)
                                                :
                                                <>Depends on the amount you pickup.</>
                                            }
                                        </div>
                                    </div>
                                </>
                               
                            }
                            <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}>
                                <div>Estimated Profit:</div>
                                <div style={{ borderTop: '1px solid black', fontWeight: 'bold' }}>
                                    {pickupRequest.PickupType == 'On Demand' ?
                                           formatter.format((pickupRequest.Quantity_Of_Cans_Bottles * .1) - pickupRequest.RecyclerPurchaseCost)
                                            :
                                            <>Depends on the amount you pickup.</>
                                    }
                                    
                                </div>
                            </div>
                        </>
                }

                


               
                {parseInt(pickupRequest.Quantity_Of_Cans_Bottles) <= 750 ? null :
                    <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}>
                        <img style={{ height: '40px', width:'80px' }} src='images/oversizedpickup.png' /><div style={{marginLeft:'5px', color:'var(--sipzee-red)', alignSelf:'center'} }>Note: Depending on the size of your vehicle, you may need to make multiple trips to complete this order.</div>
                    </div>
                }

                <div style={{
                    alignSelf: 'flex-start',
                    width: '100%',
                    minHeight: '35px',
                    borderTop: '1px solid #efefef',
                    borderBottom: '1px solid #efefef',
                    marginTop: '10px',
                    marginBottom: '10px',
                    textAlign:'right'
                }}>
                    <div style={{ textAlign: 'left', fontWeight:'bold' }}>Customer Communication</div>
                    {/*<ChatBox FloatingButton={false} loggedInUser={props.loggedInUser} order={pickupRequest} onMessageAdded={(chatMessage) => handleMessageAdded(chatMessage, pickupRequest)} />*/}

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Fab color='primary' onClick={() => handleShowCallCustomerDialog(pickupRequest)} style={{marginRight:'10px'} }><PhoneEnabledIcon /></Fab>
                        <ChatBox FloatingButton={false} order={pickupRequest} messagesViewed={(msgOrder) => chatMessagesViewed(msgOrder)} loggedInUser={props.loggedInUser} onMessageAdded={(chatMessage) => handleMessageAdded(chatMessage, pickupRequest)} recipient='recycler' />
                     
                    </div>
                    <div style={{ textAlign: 'left', fontSize:'10pt', fontStyle:'italic' }}>Please communicate with the customer as necessary to ensure a smooth pickup process.</div>
                </div>

                <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'flex-start', width: '100%', minHeight: '35px' }}>
                    {pickupRequest.LocationType === 'Business' ?
                        <>
                            <div style={{ display: 'flex', textAlign: 'left' }}>
                                <StoreIcon sx={{ fontSize: 40, color: 'var(--sipzee-yellow)' }} /> <div style={{ alignSelf: 'center' }}>This is a Business and may require certain hours</div>
                            </div>
                        </>
                        :
                        <>
                            <div style={{ display: 'flex' }}>
                                <HomeIcon sx={{ fontSize: 40, color: 'var(--sipzee-green)' }} /> <div style={{ alignSelf: 'center' }}>This is a Residence</div>
                            </div>
                        </>
                    }
                </div>

                {pickupRequest.LocationType === 'Business' ?
                    <div className='OrderBusinessHoursContainer' >
                        {buildBusinessHours(pickupRequest)}
                    </div>

                    : null}

                {selectedStores.length === 0 ?
                    null :
                    <>
                        <div style={{ textAlign: 'left' }}>The customer indicated their bottles and cans mostly came from:</div>
                        <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'flex-start', width: '100%', minHeight: '35px' }}>
                            {selectedStores}
                        </div>
                    </>
                }

                {pickupRequest.ServiceArea === 'Claimed' ? null :
                    <div style={{ marginTop: '12px', display: 'flex', justifyContent: 'flex-end' }}>
                        <Button variant='outlined' sx={{ backgroundColor: 'var(--sipzee-green)' }} onClick={(e) => props.OrderSelected(pickupRequest)}>Open <ArrowForwardIosIcon /></Button>
                    </div>
                }

            </div>)
    }

    //#endregion

    //#region Admin Orders section

    function buildAdminOrderHeader() {
        return (<div style={{ display: 'flex', width: '100%', minHeight: '30px' }}>
            <div style={{ width: '50px', display: 'flex' }} onClick={(e) => sortingChanged('Status')}>
                <Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>Status</Typography>
                {sortColumn == 'Status' && sortDirectionAsc ?
                    <KeyboardArrowDownIcon />
                    : null
                }
                {sortColumn == 'Status' && !sortDirectionAsc ?
                    <KeyboardArrowUpIcon />
                    : null
                }
            </div>
            <div style={{ width: '80px', display: 'flex' }} onClick={(e) => sortingChanged('CustomerName')}>
                <Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>Name</Typography>
                {sortColumn == 'CustomerName' && sortDirectionAsc ?
                    <KeyboardArrowDownIcon />
                    : null
                }
                {sortColumn == 'CustomerName' && !sortDirectionAsc ?
                    <KeyboardArrowUpIcon />
                    : null
                }
            </div>
            <div style={{ width: '60px', display: 'flex' }} onClick={(e) => sortingChanged('Quantity')}>
                <Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>Qty</Typography>
                {sortColumn == 'Quantity' && sortDirectionAsc ?
                    <KeyboardArrowDownIcon />
                    : null
                }
                {sortColumn == 'Quantity' && !sortDirectionAsc ?
                    <KeyboardArrowUpIcon />
                    : null
                }
            </div>
            <div style={{ width: '80px', display: 'flex' }} onClick={(e) => sortingChanged('City')}>
                <Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>City</Typography>
                {sortColumn == 'City' && sortDirectionAsc ?
                    <KeyboardArrowDownIcon />
                    : null
                }
                {sortColumn == 'City' && !sortDirectionAsc ?
                    <KeyboardArrowUpIcon />
                    : null
                }
            </div>
            <div style={{ width: '80px', display: 'flex' }} onClick={(e) => sortingChanged('Returner')}>
                <Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>Returner</Typography>
                {sortColumn == 'Returner' && sortDirectionAsc ?
                    <KeyboardArrowDownIcon />
                    : null
                }
                {sortColumn == 'Returner' && !sortDirectionAsc ?
                    <KeyboardArrowUpIcon />
                    : null
                }
            </div>

            {props.SectionDetail != 'Closed' ? null :
                <div style={{ width: '80px', display: 'flex' }} onClick={(e) => sortingChanged('ClosedDate')}>
                    <Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>Date</Typography>
                    {sortColumn == 'ClosedDate' && sortDirectionAsc ?
                        <KeyboardArrowDownIcon />
                        : null
                    }
                    {sortColumn == 'ClosedDate' && !sortDirectionAsc ?
                        <KeyboardArrowUpIcon />
                        : null
                    }
                </div>
                
            }

            {props.SectionDetail == 'CompletedToday' || props.SectionDetail == 'CompletedYesterday' ?
                <Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>Payment</Typography>
                : null
            }
            <div style={{ flexGrow: 1 }}></div>
        </div>);
    }

    function buildAdminOrderRow(order) {
        let statusIcon = null;

        let paymentStatusInfo = null;
        let closedDate = null;

        if (order.Status_Reason == 'Scheduled') {
            statusIcon = <EventAvailableIcon sx={{ color: (order.IsLate ? 'var(--sipzee-red)' : 'var(--sipzee-green)') }} />
           
            
        }
        else if (order.Status_Reason == 'Unscheduled') {
            if (order.ActivatedDateTimeUTC == null) {
                statusIcon = <span style={{ position: 'relative' }}>
                    <EmailIcon sx={{ color: 'var(--sipzee-red)' }} />
                    <HourglassFullIcon sx={{ color: 'var(--sipzee-yellow)', position: 'absolute', left: '10px', top: '2px', fontSize: '12pt' }} />
                </span>
            }
            else {
                statusIcon = <EventBusyIcon sx={{ color: 'var(--sipzee-yellow)' }} />
            }
            
        }
        else if (order.Status_Reason == 'Paid') {
            statusIcon = <CheckIcon />
            if (order.PaymentInfo != '' && typeof order.PaymentInfo === 'string') {
                order.PaymentInfo = JSON.parse(order.PaymentInfo);
            }
            if (props.SectionDetail == 'Closed') {
                closedDate = dayjs(order.PickupTimestamp.Data).format('MM/DD/YYYY');
            }

            /*
             *   1	Pending Release	Payment has been confirmed/submitted but hasn�t made it through the scrubbing/screening we do on our end.
                 2	Released	Payment has been scrubbed and made it through our screening process and is ready to be processed.
                 3	Processing	Only used by printed checks, when a check is processing it means it is being printed and mailed.
                 4	Sent	Printed checks are in the mail, digital checks have been emailed, ACHs have been sent through the bank.
                 5	Posted / Cashed	When available it means a check has been cashed and cleared by the recipient.
                 6	Returned	When we are processing returns for you and a printed check has been returned to us.
                 7	Cancelled	Payment was cancelled before being processed/sent.
                 8	Reissued	When a payment gets resent for whatever reason, another payment record is created and the original is marked as being reissued.
            */
            if (order.PaymentInfo.needs_repaired == '1') {
                paymentStatusInfo = <div style={{ width: '80px' }}>Needs Repair</div>;
            }
            else if (order.PaymentInfo.status_id == '1') {
                paymentStatusInfo = <div style={{ width: '80px' }}>Pending Release</div>;
            }
            else if (order.PaymentInfo.status_id == '2') {
                paymentStatusInfo = <div style={{ width: '80px' }}>Released</div>;
            }
            else if (order.PaymentInfo.status_id == '3') {
                paymentStatusInfo = <div style={{ width: '80px' }}>Processing</div>;
            }
            else if (order.PaymentInfo.status_id == '4') {
                paymentStatusInfo = <div style={{ width: '80px' }}>Sent</div>;
            }
            else if (order.PaymentInfo.status_id == '5') {
                paymentStatusInfo = <div style={{ width: '80px' }}>Cashed</div>;
            }
            else if (order.PaymentInfo.status_id == '6') {
                paymentStatusInfo = <div style={{ width: '80px' }}>Returned</div>;
            }
            else if (order.PaymentInfo.status_id == '7') {
                paymentStatusInfo = <div style={{ width: '80px' }}>Cancelled</div>;
            }
            else if (order.PaymentInfo.status_id == '8') {
                paymentStatusInfo = <div style={{ width: '80px' }}>Reissued</div>;
            }
        }
        else if (order.Status_Reason == 'Cancelled') {
            statusIcon = <CancelIcon />;
            if (props.SectionDetail == 'Closed') {
                closedDate = dayjs(order.Created_Date_Time_UTC.Data).format('MM/DD/YYYY');
            }
        }

        return (<div style={{ display: 'flex', width: '100%', minHeight: '30px', fontSize: '10pt' }}>
            <div style={{ width: '50px' }}>
                {statusIcon}
            </div>
            <div style={{ width: '80px' }}>
                <div>{order.CustomerName}</div>
                <div>{order.CustomerLastname}</div>
            </div>
            <div style={{ width: '60px' }}>
                {order.Quantity_Of_Cans_Bottles}
            </div>
            <div style={{ width: '80px' }}>
                {order.CustomerAddress_City}
            </div>
            <div style={{ width: '80px' }}>
                {order.Owner == 'In Process' ? 'None' : order.Owner_FirstName}
            </div>

            {props.SectionDetail != 'Closed' ? null :
                <div style={{ width: '80px' }}>
                    {closedDate}
                </div>

            }

            {paymentStatusInfo}

            <div style={{ flexGrow: 1 }}></div>
        </div>);
    }

    function buildAdminOrderExpansionArea(pickupRequest) {
        //if (pickupRequest.Status_Reason == 'Scheduled') {
        //    return buildAdminOpenOrderExpansionArea(pickupRequest)
        //}
        //else if (pickupRequest.Status_Reason == 'Unscheduled') {
        //    return buildAvailableOrderExpansionArea(pickupRequest)
        //}
        return buildAdminOpenOrderExpansionArea(pickupRequest);

        //return (
        //    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', padding: '3px' }}>
        //        <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}><div>Picked up on: </div><div>{new Date(pickupRequest.PickupTimestamp.Data).toLocaleString('en-US', { weekday: 'short' })} {new Date(pickupRequest.PickupTimestamp.Data).toLocaleString('en-US', { dateStyle: 'short' })} at {new Date(pickupRequest.PickupTimestamp.Data).toLocaleString('en-US', { timeStyle: 'short' })}</div></div>
        //        <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}><div>Estimated Bottles & Cans:</div><div>{pickupRequest.Quantity_Of_Cans_Bottles}</div></div>
        //        <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'flex-end', alignContent: 'center', width: '100%', minHeight: '30px' }}>

        //            <div style={{ marginRight: 'auto', alignSelf: 'center' }}>Actual Cans and Bottles:</div>

        //            {editingActualCansAndBottles ?
        //                <div style={{ alignSelf: 'center' }}>
        //                    <IconButton onClick={() => setEditingActualCansAndBottles(!editingActualCansAndBottles)}><BlockIcon sx={{ color: 'var(--sipzee-red)' }} /></IconButton>
        //                    <IconButton onClick={() => validateActualCansAndBottles()}><SaveIcon sx={{ color: 'var(--sipzee-green)' }} /></IconButton>
        //                </div>

        //                :

        //                <IconButton style={{ alignSelf: 'center' }} onClick={() => {
        //                    setEditingActualCansAndBottles(!editingActualCansAndBottles);
        //                    setActualCansAndBottles(pickupRequest.ActualCansAndBottles);

        //                }}>
        //                    {pickupRequest.ActualProfit == undefined || pickupRequest.ActualProfit == 0 ?
        //                        <AddCircleOutlineIcon />
        //                        :
        //                        <EditIcon />}
        //                </IconButton>
        //            }



        //            {editingActualCansAndBottles ?
        //                <TextField style={{ width: '100px', alignSelf: 'center' }} autofocus variant="outlined" onChange={(e) => setActualCansAndBottles(e.target.value)} inputProps={{ inputMode: 'numeric', pattern: '[^0-9.-]+/g,""' }} value={actualCansAndBottles} onKeyDown={(e) => actualCansAndBottlesKeyPress(e)} />
        //                :
        //                <div style={{ alignSelf: 'center' }}>{(pickupRequest.ActualCansAndBottles == undefined ? '(optional)' : '')} {pickupRequest.ActualCansAndBottles}</div>
        //            }
        //        </div>
        //        <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'flex-start', marginTop: '-8px' }}>
        //            <div style={{ fontSize: '10pt', fontStyle: 'italic' }}>Optional for your own tracking</div>
        //        </div>
        //    </div>)
    }

    function handleUpdateStolen(isStolen, pickupRequest) {
        pickupRequest.Stolen = isStolen;

        updateOrder(pickupRequest, false, false);
    }

    function updateOrder(pickupRequest, notifyCustomerOnUpdate, notifyRecyclerOnUpdate) {
        
        let postData = {
            updateRequest: JSON.stringify(pickupRequest),
            notifyCustomer: notifyCustomerOnUpdate,
            notifyRecycler: notifyRecyclerOnUpdate
        }


        TokenService.adminServicePost(postData, 'PickupRequest_UpdateOrder', '')
            .then((response) => {
                if (response !== null) {
                    response = response[Object.keys(response)[0]];
                    if (response.Result === "SUCCESS") {
                        let requestData = JSON.parse(response.JsonData);

                        let orderTemp = JSON.parse(requestData.PickupRequest);

                        let clonedOrders = cloneDeep(orders); // deep clone so the reference is updated and setLoggedInUser re-renders
                        for (let i = 0; i < clonedOrders.length; i++) {
                            if (clonedOrders[i].OrderGUID === orderTemp.OrderGUID) {
                                clonedOrders[i] = orderTemp;
                                break;
                            }
                        }
                        setOrders(clonedOrders);

                        enqueueSnackbar('Order has been updated', {
                            variant: 'success',
                        });
                    }
                    else if (response.Result === "FAIL") {

                        if (response.Message = 'Validation Errors') {
                            let errors = JSON.parse(response.JsonData);
                            let message = '';
                            for (let i = 0; i < errors.length; i++) {
                                message += errors[i] + "\r\n";
                            }
                            enqueueSnackbar(message, {
                                variant: 'error',
                            });
                        }
                        else {
                            enqueueSnackbar(response.Message, {
                                variant: 'error',
                            });
                        }
                    }
                }
            })
            .catch((response) => {
              
                if (response !== null) {
                    if (response.Result === "FAIL") {
                        enqueueSnackbar('Oops, something went wrong', {
                            variant: 'error',
                        });
                    }

                }
            });


    }

    function buildAdminOpenOrderExpansionArea(pickupRequest) {
        let selectedStores = RetailStores.getStoreIcons(pickupRequest);

        return (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', padding: '3px' }}>
                {pickupRequest.ActivatedDateTimeUTC !== null ? null :
                    <div style={{ display: 'flex' }}>
                        <div style={{position:'relative'} }>
                            <EmailIcon sx={{ color: 'var(--sipzee-red)' }} />
                            <HourglassFullIcon sx={{ color: 'var(--sipzee-yellow)', position: 'absolute', left: '10px', top: '10px', fontSize: '12pt' }} />
                        </div>
                        <div style={{ alignSelf: 'center', color: 'var(--sipzee-red)' }}>Request has not been Activated</div>
                    </div>
                }

                {pickupRequest.IsLate ? 
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                        {pickupRequest.ReturnerLatePickupSilencedUntil.Data === null ?
                            <div style={{ alignSelf: 'center' }}>
                                This pickup is late.
                            </div>
                            : null
                        }
                        <div>
                            {
                                pickupRequest.ReturnerLatePickupSilencedUntil.Data === null ?
                                    <Fab onClick={() => { setShowSilenceConfirmation(pickupRequest)} }>
                                        <VolumeOffIcon style={{ color: 'var(--sipzee-red)' }} />
                                    </Fab>
                                    :
                                    <div style={{display:'flex'} }>
                                        <VolumeOffIcon style={{ color: 'var(--sipzee-red)', alignSelf: 'center' }} />
                                        <div>Notifications Silenced until {pickupRequest.ReturnerLatePickupSilencedUntil.Data}
                                        </div>
                                    </div>
                            }
                            
                        </div>
                    </div>
                    :
                    null
                }
               
                <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}><div>Estimated Quantity:</div><div>{pickupRequest.Quantity_Of_Cans_Bottles}</div></div>

                <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}><div>Estimated Bottle Value:</div><div>{formatter.format(pickupRequest.Quantity_Of_Cans_Bottles * .1)}</div></div>


                {(pickupRequest.TipAmount === '' || pickupRequest.TipAmount === '0')
                    ?
                    <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px', color: 'var(--sipzee-red)' }}><div>Purchase Cost: </div><div>{formatter.format(pickupRequest.RecyclerPurchaseCost)}</div></div>

                    :
                    <>
                        <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}><div>Purchase Cost: </div><div>{formatter.format(pickupRequest.RecyclerPurchaseCost + parseFloat(pickupRequest.TipAmount))}</div></div>
                        <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}><div>Tip Amount:</div><div>({formatter.format(pickupRequest.TipAmount)})</div></div>
                        <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px', color: 'var(--sipzee-red)' }}><div>Purchase Cost: </div><div>{formatter.format(pickupRequest.RecyclerPurchaseCost)}</div></div>
                    </>

                }

              
                <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}><div>Estimated Profit for Recycler:</div><div style={{ borderTop: '1px solid black', fontWeight: 'bold' }}>{formatter.format((pickupRequest.Quantity_Of_Cans_Bottles * .1) - pickupRequest.RecyclerPurchaseCost)}</div></div>

                {pickupRequest.Status_Reason != 'Paid' ? null :
                    <div style={{borderTop:'1px solid black', marginTop:'10px', marginBottom:'10px'} }>
                        <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '25px' }}><div>Recycler Paid: </div><div>{formatter.format(pickupRequest.FinalPaymentByReturner)}</div></div>
                        <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '25px' }}><div>Customer Received: </div><div>{formatter.format(pickupRequest.FinalPayoutToClient)}</div></div>
                        <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '25px' }}><div>Sipzee Profit: </div><div style={{fontWeight:'bold'} }>{formatter.format(pickupRequest.FinalPaymentByReturner - pickupRequest.FinalPayoutToClient)}</div></div>
                    </div>

                }


                {parseInt(pickupRequest.Quantity_Of_Cans_Bottles) <= 750 ? null :
                    <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}>
                        <img style={{ height: '40px', width: '80px' }} src='images/oversizedpickup.png' /><div style={{ marginLeft: '5px', color: 'var(--sipzee-red)', alignSelf: 'center' }}>Note: Depending on the size of your vehicle, you may need to make multiple trips to complete this order.</div>
                    </div>
                }

                <div style={{
                    alignSelf: 'flex-start',
                    width: '100%',
                    minHeight: '35px',
                    borderTop: '1px solid #efefef',
                    borderBottom: '1px solid #efefef',
                    marginTop: '10px',
                    marginBottom: '10px',
                    textAlign: 'right'
                }}>
                    <div style={{ textAlign: 'left', fontWeight: 'bold' }}>Customer Communication</div>
                    {/*<ChatBox FloatingButton={false} loggedInUser={props.loggedInUser} order={pickupRequest} onMessageAdded={(chatMessage) => handleMessageAdded(chatMessage, pickupRequest)} />*/}

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <div style={{ marginRight: 'auto' }}>
                            <div style={{textAlign: 'left'}}>Conf# : {pickupRequest.RequestID}</div>
                            <div style={{textAlign: 'left' }}>Name: {pickupRequest.CustomerName} {pickupRequest.CustomerLastname}</div>
                        </div>
                        <Fab color='primary' onClick={() => handleShowCallCustomerDialog(pickupRequest)} style={{ marginRight: '10px' }}><PhoneEnabledIcon /></Fab>
                        <ChatBox FloatingButton={false} order={pickupRequest} messagesViewed={(msgOrder) => { } } loggedInUser={props.loggedInUser} onMessageAdded={(chatMessage) => handleMessageAdded(chatMessage, pickupRequest)} recipient='admin' />

                    </div>
                    <div style={{ textAlign: 'left', fontSize: '10pt', fontStyle: 'italic' }}>Please communicate with the customer as necessary to ensure a smooth pickup process.</div>
                    {props.Section != 'Admin' ? null :
                        <div style={{display:'flex'} }>
                            <div style={{ alignSelf: 'center' }}>Mark as Stolen </div>
                            <StyledCheckbox checked={pickupRequest.Stolen}
                                onChange={(e) => { handleUpdateStolen(e.target.checked, pickupRequest) }} />
                            <img src={pickupRequest.Stolen ? 'images/StolenRed.svg' : 'images/StolenGray.svg'} style={{height:'30px', alignSelf:'center'} } />
                        </div>
                    }
                </div>

               

                <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'flex-start', width: '100%', minHeight: '35px' }}>
                    {pickupRequest.LocationType === 'Business' ?
                        <>
                            <div style={{ display: 'flex', textAlign: 'left' }}>
                                <StoreIcon sx={{ fontSize: 40, color: 'var(--sipzee-yellow)' }} /> <div style={{ alignSelf: 'center' }}>This is a Business and may require certain hours</div>
                            </div>
                        </>
                        :
                        <>
                            <div style={{ display: 'flex' }}>
                                <HomeIcon sx={{ fontSize: 40, color: 'var(--sipzee-green)' }} /> <div style={{ alignSelf: 'center' }}>This is a Residence</div>
                            </div>
                        </>
                    }
                </div>

                {pickupRequest.LocationType === 'Business' ?
                    <div className='OrderBusinessHoursContainer' >
                        { buildBusinessHours(pickupRequest) }
                    </div>

                    : null}

                {selectedStores.length === 0 ?
                    null :
                    <>
                        <div style={{ textAlign: 'left' }}>The customer indicated their bottles and cans mostly came from:</div>
                        <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'flex-start', width: '100%', minHeight: '35px' }}>
                            {selectedStores}
                        </div>
                    </>
                }

                {pickupRequest.ServiceArea === 'Claimed' ? null :
                    <div style={{ marginTop: '12px', display: 'flex', justifyContent: 'flex-end' }}>
                        {pickupRequest.History == undefined || pickupRequest.History.HistoryItems.length == 0 ? null :
                            <div style={{ marginRight:'auto', alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}>
                                <Fab onClick={() => handleShowHistory(pickupRequest, 'admin')} style={{ marginRight: '10px' }}><RestoreIcon sx={{ fontSize: 40, color: 'var(--sipzee-yellow)' }} /></Fab>
                            </div>
                        }
                        <Button variant='outlined' sx={{ backgroundColor: 'var(--sipzee-green)' }} style={{ alignSelf: 'center' }} onClick={(e) => props.OrderSelected(pickupRequest)}>Open <ArrowForwardIosIcon /></Button>
                    </div>
                }

            </div>)
    }

    //#endregion

    function handleShowHistory(pickupRequest, viewType) {
        setAlertDialog({
            show: true,
            title: '',
            message:
                <div>
                    <div style={{ display: 'flex', justifyContent:'space-between', borderBottom:'2px solid var(--sipzee-gray-3)' }}>
                        <RestoreIcon sx={{ color: 'var(--sipzee-gray-2)', fontSize: 30 }} style={{ alignSelf: 'center' }} />
                        <div style={{ marginLeft: '15px', marginRight: '15px', alignSelf: 'center' }}>
                            <div style={{ fontWeight: 'bold' }}>
                                Order History
                            </div>
                        </div>

                    </div>
                    <div>
                        {pickupRequest.History.HistoryItems.map((item, index) => {
                            return <div style={{ borderBottom: '1px solid var(--sipzee-gray-2)', marginTop: '15px', paddingBottom: '10px' }}>
                                {item.ChangeType == 'Chat' ? null :
                                    <div style={{display:'flex', justifyContent:'space-between'} }>
                                        <span style={{ fontWeight: 'bold' }}>{item.ChangeBy}</span> <span style={{ fontStyle: 'italic', fontSize: '10pt' }}>{dayjs(item.ChangeDateTime).format('ddd, MMM D')} at {dayjs(item.ChangeDateTime).format('h:mm a')}</span>
                                    </div>
                                } 
                                <div>
                                    {
                                        item.ChangeType === 'Chat' ?
                                            <div style={{ display: 'flex' }}>
                                                <Avatar
                                                    alt="Photo"
                                                    src={getAvatar(item)}
                                                    sx={{ width: 55, height: 55, alignSelf: 'center' }}
                                                />
                                                <div style={{ alignSelf: 'center', marginLeft: '10px' } }>
                                                    <div style={{ alignSelf: 'center' }}> {item.Description[0]}</div>
                                                    <div style={{ fontStyle: 'italic', fontSize:'8pt' }}>
                                                        {dayjs(item.ChangeDateTime).format('ddd, MMM D')} at {dayjs(item.ChangeDateTime).format('h:mm a')}
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                        item.Description.map((desc, descIndex) => {
                                            return <div style={{ marginLeft: '15px' }}>{desc}</div>
                                        })
                                    }
                                </div>
                            </div>
                        })
                        }
                    </div>
                </div>,
            closeButton: 'Close',
        });
    }


    function getAvatar(item) {
        if (item.ChangeBy === 'Admin') {
            return 'images/SipzeeAvatar.png';
        }
        else if (item.ChangeBy == 'Recycler') {
            if (item.Avatar.toUpperCase().indexOf('HTTPS://') > -1) {
                return item.Avatar;
            }
            else {
                if (window.location.href.indexOf('localhost') > -1) {
                    return 'https://sipzee.com' + item.Avatar;
                }
                else if (window.location.href.indexOf('test.sipzee.com') > -1) {
                    return 'https://test.sipzee.com' + item.Avatar;
                }
                else {
                    return 'https://sipzee.com' + item.Avatar;
                }

            }
        }
        else {
            return 'images/CustomerChatAvatar.png';
        }
    }

    function handleShowCallCustomerDialog(pickupRequest) {


        setAlertDialog({
            show: true,
            title: '',
            message:
                <div style={{ display: 'flex' }}>
                    <PhoneEnabledIcon sx={{ color: 'var(--sipzee-green)', fontSize: 50 }} style={{ alignSelf: 'center' }} />
                    <div style={{ marginLeft: '15px', marginRight: '15px' }}>
                        <div>
                            This will initiate a call to you from Sipzee, then connect you to the customer.
                        </div>
                        <div style={{ marginTop: '20px' }}>
                            Your number will not be visible to the customer.
                        </div>

                        <div style={{ marginTop: '20px', display:'flex', justifyContent:'center' }}>
                            <Button variant='outlined' sx={{ backgroundColor: 'var(--sipzee-yellow)' }} onClick={() => handleInitiateCallCustomer(pickupRequest)}>Initiate Call</Button>
                        </div>
                    </div>

                </div>,
            closeButton: 'Cancel',
        });

        
    }

    function handleInitiateCallCustomer(pickupRequest) {
        setAlertDialog({
            show: false,
            title: '',
            message: '',
            closeButton: ''
        });

        let postData = {
            orderGUID: pickupRequest.OrderGUID
        }
        TokenService.post(postData, 'Returner_ContactCustomerByPhone')
            .then((response) => {
                if (response.Result == "SUCCESS") {

                }
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });
    }

//#region Available Orders section

    function buildAvailableOrderHeader() {
        return (<div style={{ display: 'flex', width: '100%', minHeight: '30px' }}>
            <div style={{ width: '70px', display: 'flex' }} onClick={(e) => sortingChanged('AvailableDate')}>
                <Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>When</Typography>
                {sortColumn == 'AvailableDate' && sortDirectionAsc ?
                    <KeyboardArrowDownIcon />
                    : null
                }
                {sortColumn == 'AvailableDate' && !sortDirectionAsc ?
                    <KeyboardArrowUpIcon />
                    : null
                }
            </div>
            <div style={{ width: '80px', display: 'flex' }} onClick={(e) => sortingChanged('Location')}>
                <Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>Where</Typography>
                {sortColumn == 'Location' && sortDirectionAsc ?
                    <KeyboardArrowDownIcon />
                    : null
                }
                {sortColumn == 'Location' && !sortDirectionAsc ?
                    <KeyboardArrowUpIcon />
                    : null
                }
            </div>
            <div style={{ width: '80px', display: 'flex' }} onClick={(e) => sortingChanged('Quantity')}>
                <Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>How Many</Typography>
                {sortColumn == 'Quantity' && sortDirectionAsc ?
                    <KeyboardArrowDownIcon />
                    : null
                }
                {sortColumn == 'Quantity' && !sortDirectionAsc ?
                    <KeyboardArrowUpIcon />
                    : null
                }
            </div>
            <div style={{ width: '80px', display: 'flex' }} onClick={(e) => sortingChanged('Estimated Profit')}>
                <Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>How Much</Typography>
                {sortColumn == 'Estimated Profit' && sortDirectionAsc ?
                    <KeyboardArrowDownIcon />
                    : null
                }
                {sortColumn == 'Estimated Profit' && !sortDirectionAsc ?
                    <KeyboardArrowUpIcon />
                    : null
                }
            </div>
            <div style={{ flexGrow: 1 }}></div>
        </div>);
    }

    function buildAvailableOrderRow(order) {
        let whenDate = '';
        let availDate = (dayjs(order.CustomerDateAvailableForPickup.Data));
        let tomorrowDate = dayjs().add(1, 'day').endOf('day');

       // order.ServiceArea = 'Claimed'
        //availDate = dayjs('2022-11-25');
        if (order.ServiceArea === 'Claimed') {
            whenDate = <Paper className='OpenOrderAvailability' style={{ backgroundColor: 'var(--sipzee-gray-3)' }}>Just Claimed</Paper>;
        }
        else if (availDate < dayjs().endOf('day')) {
            whenDate = <Paper className='OpenOrderAvailability' style={{ backgroundColor: 'var(--sipzee-green-2)' }}>Now</Paper>;
        }
        else if (availDate < tomorrowDate) {
            whenDate = <Paper className='OpenOrderAvailability' style={{ backgroundColor: 'var(--sipzee-yellow-2)' }}>Tomorrow</Paper>;
        }
        else {
            whenDate = <Paper className='OpenOrderAvailability' style={{ backgroundColor: 'var(--sipzee-red-2)', top:'4px' }}>
                <div>Soon</div>
                <div>({new Date(order.CustomerDateAvailableForPickup.Data).toLocaleString('en-US', { weekday: 'short' })})</div>
            </Paper>;
        }

        let where = '';
        if (order.CustomerAddress_City.toLowerCase() == 'grand rapids') {
            where = <div>G. Rapids</div>
        }

        if (order.ServiceArea == 'Nearby') {
            where = <div style={{ display: 'flex' }}>
                <div>{where}</div>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginLeft: '10px' }} >
                    <img src='Images/nearbyIconText.svg' style={{ height: '29px', width: '45px', alignSelf: 'center' }} />
                    <div style={{ fontSize: '6pt', textAlign: 'center' }}>{order.Distance.toPrecision(2)} mi {order.FromZip} </div>
                </div>
            </div>
        }
        else {
            where = <div>{order.CustomerAddress_City}</div>
        }

        return (
            <div>
                <div style={{ display: 'flex', width: '100%', minHeight: '30px', fontSize: '10pt' }}>
                    <div style={{ width: '65px' }}>
                        {whenDate}
                    </div>
                    <div style={{ width: '80px' }}>
                        {where}
                    </div>
                    <div style={{ width: '80px' }}>
                        {order.Quantity_Of_Cans_Bottles}
                    </div>
                    <div style={{ width: '80px' }}>
                        {formatter.format(calculateEstimatedProfit(order))}
                    </div>

                    <div style={{ flexGrow: 1 }}></div>
                </div>
                <div style={{ fontSize: '9pt', display: 'flex', marginTop: '5px' }}>
                    {
                        order.FirstViewed == null ?
                            <div style={{ display: 'flex' }}><DoneAllIcon style={{ color: 'var(--sipzee-gray)' }} />
                                <div style={{ alignSelf: 'center', marginLeft: '5px' }}>Not yet viewed</div>
                            </div>
                            :
                            <div style={{ display: 'flex' }}>
                                <DoneAllIcon style={{ color: 'var(--sipzee-green)' }} />
                                <div style={{ alignSelf: 'center', marginLeft: '5px' }}>You viewed this on {dayjs(order.FirstViewed).format('ddd, MMM D')} at {dayjs(order.FirstViewed).format('h:mm a')}</div>
                            </div>
                    }
                </div>
                <div style={{ display: 'flex', width: '100%' }}>
                    {order.MustRecycleFirst == false ? null :
                        <div style={{marginTop:'5px', marginRight:'10px'} }>
                            <IconButton style={{ backgroundColor: 'rgba(0, 0, 0, 0.08)' }} onClick={() => showMoreInfo('MustRecycleFirst')}>
                                <img src='images/RecycleFirstIndicatorGreen.svg' style={{ height: '30px' }} />
                            </IconButton>
                            <div style={{ fontSize: '9pt' }}>Must Recycle First</div>
                        </div>
                    }
                    {order.PickupType == 'Continuous' &&
                        <div style={{ marginTop: '5px', marginRight:'10px' }}>
                            <IconButton style={{ backgroundColor: 'rgba(0, 0, 0, 0.08)' }} onClick={() => showMoreInfo('ContinuousPickup')}>
                                <img src='images/ContinuousPickupIcon.png' style={{ height: '30px' }} />
                            </IconButton>
                            <div style={{ fontSize: '9pt' }}>Continuous Pickup</div>
                        </div>
                    }
                </div>
                
            </div>);
    }

    function buildAvailableOrderExpansionArea(pickupRequest) {

       // let availDate = (dayjs(pickupRequest.CustomerDateAvailableForPickup.Data));
        let selectedStores = RetailStores.getStoreIcons(pickupRequest);
        
        return (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', padding: '3px' }}>

                {pickupRequest.IsLate ?
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                        {pickupRequest.ReturnerLatePickupSilencedUntil.Data === null ?
                            <div style={{ alignSelf: 'center' }}>
                                This pickup is late.
                            </div>
                            : null
                        }
                        <div>
                            {
                                pickupRequest.ReturnerLatePickupSilencedUntil.Data === null ?
                                    <Fab onClick={() => { setShowSilenceConfirmation(pickupRequest) }}>
                                        <VolumeOffIcon style={{ color: 'var(--sipzee-red)' }} />
                                    </Fab>
                                    :
                                    <div style={{ display: 'flex' }}>
                                        <VolumeOffIcon style={{ color: 'var(--sipzee-red)', alignSelf: 'center' }} />
                                        <div>Notifications Silenced until {pickupRequest.ReturnerLatePickupSilencedUntil.Data}
                                        </div>
                                    </div>
                            }

                        </div>
                    </div>
                    :
                    null
                }

                <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}><div>Estimated Quantity:</div><div>{pickupRequest.Quantity_Of_Cans_Bottles}</div></div>

                <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}>
                    <div style={{textAlign:'left'}}>Estimated Bottle Value:</div>
                    <div style={{textAlign:'right'}}>
                        {pickupRequest.PickupType == 'On Demand' ? 
                            formatter.format(pickupRequest.Quantity_Of_Cans_Bottles * .1)
                        :
                            <>Depends on amount picked up.</>
                        }
                    </div>
                </div>

     
                {(pickupRequest.TipAmount === '' || pickupRequest.TipAmount === '0')
                    ? 
                    <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px', color: 'var(--sipzee-red)' }}><div>Your Purchase Cost: </div>
                        <div>
                            {pickupRequest.PickupType == 'On Demand' ? 
                                formatter.format(pickupRequest.RecyclerPurchaseCost)
                            :
                                <>Depends on amount picked up</>
                            }

                            </div>
                    </div>

                    :
                    <>
                        <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}>
                            <div>Purchase Cost: </div>
                            <div>
                                {pickupRequest.PickupType == 'On Demand' ? 
                                    formatter.format(pickupRequest.RecyclerPurchaseCost + parseFloat(pickupRequest.TipAmount))
                                    :
                                    <>Depends on amount picked up</>
                                }
                                </div>
                        </div>
                        <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}><div>Tip Amount:</div><div>({formatter.format(pickupRequest.TipAmount)})</div></div>
                        <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px', color: 'var(--sipzee-red)' }}>
                            <div>Your Purchase Cost: </div>
                            <div>
                                {pickupRequest.PickupType == 'On Demand' ? 
                                    formatter.format(pickupRequest.RecyclerPurchaseCost)
                                :
                                    <>Depends on amount picked up</>
                                }

                            </div>
                        </div>
                    </>

                }

                <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}>
                    <div>Estimated Profit:</div><div style={{ borderTop: '1px solid black', fontWeight: 'bold' }}>
                        {pickupRequest.PickupType == 'On Demand' ? 
                            formatter.format((pickupRequest.Quantity_Of_Cans_Bottles * .1) - pickupRequest.RecyclerPurchaseCost)
                        :
                            <>Depends on amount picked up</>
                        }
                    </div>
                </div>

                {parseInt(pickupRequest.Quantity_Of_Cans_Bottles) <= 750 ? null :
                    <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}>
                        <img style={{ height: '40px', width:'80px' }} src='images/oversizedpickup.png' /><div style={{ marginLeft: '5px', color: 'var(--sipzee-red)', alignSelf: 'center' }}>Note: Depending on the size of your vehicle, you may need to make multiple trips to complete this order.</div>
                    </div>
                }

                <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'flex-start', width: '100%', minHeight: '35px' }}>
                    {pickupRequest.LocationType === 'Business' ?
                        <>
                            <div style={{display:'flex', textAlign:'left'} }>
                                <StoreIcon sx={{ fontSize: 40, color: 'var(--sipzee-yellow)' }} /> <div style={{ alignSelf: 'center' }}>This is a Business and may require certain hours</div>
                            </div>
                        </>
                        :
                        <>
                            <div style={{ display: 'flex' }}>
                                <HomeIcon sx={{ fontSize: 40, color: 'var(--sipzee-green)' }} /> <div style={{ alignSelf: 'center' }}>This is a Residence</div>
                            </div>
                        </>
                    }
                </div>   

                {pickupRequest.LocationType === 'Business' ?
                    <div className='OrderBusinessHoursContainer' >
                        {buildBusinessHours(pickupRequest)}
                    </div>
                
                    : null}

                {selectedStores === null || selectedStores.length === 0 ?
                    null :
                    <>
                        <div style={{textAlign:'left'} }>The customer indicated their bottles and cans mostly came from:</div>
                    <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'flex-start', width: '100%', minHeight: '35px' }}>
                        {selectedStores }
                        </div>
                    </>
                }

                {pickupRequest.ServiceArea === 'Claimed' ? null :
                    <div style={{marginTop:'12px', display:'flex', justifyContent:'flex-end'} }>
                        <Button variant='outlined' sx={{ backgroundColor: 'var(--sipzee-green)' }} onClick={(e) => props.OrderSelected(pickupRequest)}>View Details <ArrowForwardIosIcon /></Button>
                    </div>
                }

            </div>)
    }

//#endregion


    function buildBusinessHours(order) {
        let hours = [];

        if (order.MonHours !== '') {
            let openHours = getHours(order.MonHours);
            hours.push(<div className='OrderBusinessHours'><div>Mon </div><div>{openHours.start.format("hh:mm A")} to {openHours.end.format("hh:mm A")}</div></div>);
        }
        if (order.TueHours !== '') {
            let openHours = getHours(order.TueHours);
            hours.push(<div className='OrderBusinessHours'><div>Tue </div><div>{openHours.start.format("hh:mm A")} to {openHours.end.format("hh:mm A")}</div></div>);
        }
        if (order.WedHours !== '') {
            let openHours = getHours(order.WedHours);
            hours.push(<div className='OrderBusinessHours'><div>Wed </div><div>{openHours.start.format("hh:mm A")} to {openHours.end.format("hh:mm A")}</div></div>);
        }
        if (order.ThuHours !== '') {
            let openHours = getHours(order.ThuHours);
            hours.push(<div className='OrderBusinessHours'><div>Thu </div><div>{openHours.start.format("hh:mm A")} to {openHours.end.format("hh:mm A")}</div></div>);
        }
        if (order.FriHours !== '') {
            let openHours = getHours(order.FriHours);
            hours.push(<div className='OrderBusinessHours'><div>Fri </div><div>{openHours.start.format("hh:mm A")} to {openHours.end.format("hh:mm A")}</div></div>);
        }
        if (order.SatHours !== '') {
            let openHours = getHours(order.SatHours);
            hours.push(<div className='OrderBusinessHours'><div>Sat </div><div>{openHours.start.format("hh:mm A")} to {openHours.end.format("hh:mm A")}</div></div>);
        }
        if (order.SunHours !== '') {
            let openHours = getHours(order.SunHours);
            hours.push(<div className='OrderBusinessHours'><div>Sun </div><div>{openHours.start.format("hh:mm A")} to {openHours.end.format("hh:mm A")}</div></div>);
        }

        return hours;

    }
    function getHours(hourString) {
        let startHours = hourString.split(' to ')[0];
        let endHours = hourString.split(' to ')[1];
        let openingTime = dayjs().set('hour', parseInt(startHours.split(':')[0])).set('minute', parseInt(startHours.split(':')[1])).set('second', 0);
        let closingTime = dayjs().set('hour', parseInt(endHours.split(':')[0])).set('minute', parseInt(endHours.split(':')[1])).set('second', 0);
        return { start: openingTime, end: closingTime }

    }
   

    return (

        <div  componentname='OrderListTable'>

            {
                props.Section === 'Completed' ? buildCompletedPickupsSummaryArea() : ''
            }

            <div style={{ width: '100%' }}>
                <Card className='OrderListHeader' style={{backgroundColor:'var(--sipzee-gray-2)', color:'white'} }>
                    {props.Section === 'Completed' ? buildCompletedOrderHeader() : null}
                    {props.Section === 'Available' ? buildAvailableOrderHeader() : null}
                    {props.Section === 'Open' ? buildOpenOrderHeader() : null}
                    {props.Section === 'Admin' ? buildAdminOrderHeader() : null}
                   
                </Card>
                {

                    orders.map((order, index) => {
                        return <Accordion key={'OrderItem_' + order.RequestID} expanded={selectedRow === order.RequestID} onChange={(e) => handleRowClick(e, order)}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1bh-content"
                                className={(selectedRow === order.RequestID ? 'ExpandableRow-Selected ' : ' ') + (index % 2 == 0 ? 'AccordionAlternate ' : ' ')}

                            >
                                {props.Section === 'Completed' ? buildCompletedOrderRow(order) : null}
                                {props.Section === 'Available' ? buildAvailableOrderRow(order) : null}
                                {props.Section === 'Open' ? buildOpenOrderRow(order) : null}
                                {props.Section === 'Admin' ? buildAdminOrderRow(order) : null}
                            </AccordionSummary>
                            <AccordionDetails>
                                {props.Section === 'Completed' ? buildCompletedOrderExpansionArea(order) : null}
                                {props.Section === 'Available' ? buildAvailableOrderExpansionArea(order) : null}
                                {props.Section === 'Open' ? buildOpenOrderExpansionArea(order) : null}
                                {props.Section === 'Admin' ? buildAdminOrderExpansionArea(order) : null}
                            </AccordionDetails>
                        </Accordion>
                    })
                }

                {showSilenceConfirmation == null ? null :
                    <ConfirmSilenceLateNotification pickupRequest={showSilenceConfirmation} Close={(didAccept, pickupRequest) => handleConfirmSilenceLateNotificationClosed(didAccept, pickupRequest)} />
                }
                <AlertDialog isShown={alertDialog.show} close={() => setAlertDialog({ show: false })} Title={alertDialog.title} Message={alertDialog.message} CloseText={alertDialog.closeButton} />
            </div>
        </div>
    );
}

export default OrderListTable;



